export default __webpack_public_path__ + "static/media/3.7d056770.png";